<script lang="ts" setup>
import { useEvents } from '~/composables/event-drawing-lots/use-events'
const { isMobile } = useDevice()
const $isLighthouseBot = useNuxtApp().$isLighthouseBot as boolean
const { isShowFloating, redirectToEvent, closeFloating } = useEvents()
</script>
<template>
  <div v-if="isShowFloating && !$isLighthouseBot" class="button-floating">
    <div class="button-close" @click="closeFloating" />
    <img
      class="button-floating__thumb"
      :src="
        isMobile
          ? '/images/event-drawing-lots/floating-mb.webp'
          : '/images/event-drawing-lots/floating.webp'
      "
      alt="Floating"
      @click="redirectToEvent"
    />
  </div>
</template>
<style lang="scss">
@import '~/assets/styles/components/event-drawing-lots/common/floating.scss';
</style>
